import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Button, Card, Space, theme } from "antd";
import { IoAdd } from "react-icons/io5";
import {
  clearResponsables,
  getResponsables,
  newResponsable,
} from "../ResponsablesSlice/Responsables.slice";
import { objectToUrlParams } from "../../../../utils/helpersFunction";
import { ResponsableItem } from "../ResponsableItem/ResponsableItem";
import {
  setPropertiesInstitution,
  updateInstitution,
} from "../../../../pages/Institutions/Slices/Institution.slice";
import {
  setPropertiesPrincipal,
  updatePrincipal,
} from "../../../../pages/Principals/Slices/Principal.slice";
import {
  ActionRoleSpecific,
  onlyRoleMapping,
  UserHasLevel,
} from "../../../../engine/AuthRoute";
import { roles, statusPrestationsValues } from "../../../../utils/constants";
import routes from "../../../../engine/routes";
import { usePrevious } from "@uidotdev/usehooks";
import {
  isCheckedAddress,
  typeAddress,
} from "../ResponsableItem/ResponsableHelpers";
import { modalsByContext } from "../../../components/Modals/modals";
import { FcCancel } from "react-icons/fc";
import { ModalContext } from "../../../../engine/context/Modal.provider";
import { CreateApplicant } from "../../../components/CreateApplicant/CreateApplicant";

export const ResponsablesList = ({
  institution = null,
  search = {},
  principal = null,
}) => {
  const { loading, responsables } = useSelector(state => state.responsables);

  const context = useContext(ModalContext);

  const dispatch = useDispatch();

  const {
    token: { colorPrimary },
  } = theme.useToken();

  const dispatchActionGetResponsables = () => {
    const search = objectToUrlParams({
      institution: institution?._id,
      principal: principal?._id,
    });

    dispatch(getResponsables(search));
  };

  useEffect(() => {
    dispatchActionGetResponsables();

    return () => {
      dispatch(clearResponsables());
    };
  }, []);

  // const changeDefault = address => {
  //   if (institution !== null) {
  //     dispatch(
  //       setPropertiesInstitution({
  //         [defaultProjection]: address?._id || null,
  //       }),
  //     );
  //
  //     dispatch(updateInstitution());
  //   }
  //
  //   if (principal !== null) {
  //     dispatch(
  //       setPropertiesPrincipal({
  //         defaultAddress: address?._id || null,
  //       }),
  //     );
  //
  //     dispatch(updatePrincipal());
  //   }
  // };

  return (
    <>
      <Space direction={"vertical"} size={"middle"} style={{ width: "100%" }}>
        <UserHasLevel rule={routes.institutions().responsables} action={"c"}>
          <CreateApplicant
            institution={institution}
            key={Math.random()}
            name={"intervenant"}
            // formRef={formRef}
            onCreated={_id => {
              dispatchActionGetResponsables();
              // setChange(_id);
            }}
            opener={
              <Button
                style={{ flex: 1, width: "100%", fontWeight: 600 }}
                size={"large"}
                type={"dashed"}
                danger
              >
                <IoAdd style={{ margin: 0, color: colorPrimary }} size={30} />
                Ajouter un responsable d'entretien
              </Button>
            }
          />
        </UserHasLevel>
        {loading ? (
          <>
            <Card loading={true} style={{ width: "100%" }}></Card>
            <Card loading={true} style={{ width: "100%" }}></Card>
            <Card loading={true} style={{ width: "100%" }}></Card>
          </>
        ) : (
          responsables.map(responsable => (
            <ResponsableItem
              institution={institution}
              principal={principal}
              responsable={responsable}
              // changeDefault={changeDefault}
              // isChecked={isCheckedAddress({
              //   responsable,
              //   institution,
              //   principal,
              // })}
            />
          ))
        )}
      </Space>
    </>
  );
};
